import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { checkAthenticatedUser, getUser, removeStorage } from "utils/auth";
import { callGetApi, callPostApi } from "utils/api";
import {
  Input,
  Button,
  Form,
  SuccessNotification,
  ErrorNotification,
  message,
} from "components/common";

import { Wrapper } from "./ResetPassword.styled";

const ResetPassword = () => {
  const history = useHistory();
  const param = useParams();
  const [isloading, setIsLoading] = useState(false);

  const onFinish = (values) => {
    setIsLoading(true);
    let formData = {
      token: param?.id,
      password: values?.password,
    };
    callPostApi("/auth/action/perform/reset-password", formData, (data) => {
      setIsLoading(false);
      SuccessNotification("Password Reset Successful");
      removeStorage();
      history.push("/login");
    }, (err) => {
      setIsLoading(false);
      console.log(err);
    }
    );
  };

  return (
    <Wrapper>
      <div className="form-container">
        <div className="heading-container">
          <h1>PASSWORD RESET</h1>
        </div>
        <>
          <div className="reset-requirement">
            <h6 className="reset-heading">
              Your Password Must Be At Atleast 8 Character Long and Contain 1
              uppercase and 1 Lower Case Letter, And Number.
            </h6>
          </div>
          <div className="form-details-container">
            <Form
              name="basic"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              autoComplete="off"
            >
              <Form.Item
                name="password"
                rules={[
                  { required: true, message: "" },
                  { min: 8, message: "" },
                  {
                    validator: (_, value) =>
                      value &&
                        value.match(/[A-Z]/i) &&
                        value.match(/[0-9]/i) &&
                        value.match(/[" !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~"]/i)
                        ? Promise.resolve("")
                        : Promise.reject("Password not match with criteria"),
                  },
                ]}
              >
                <div className="password-container">
                  <Input type="password" placeholder="New Password..." />
                </div>
              </Form.Item>
              <Form.Item
                name="confirm_password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your confirm password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }

                      return Promise.reject(
                        new Error("Confirm password does not match")
                      );
                    },
                  }),
                ]}
              >
                <div className="password-container">
                  <Input
                    type="password"
                    placeholder="Confirm New Password..."
                  />
                </div>
              </Form.Item>
              <Form.Item>
                <div className="login-button-container">
                  <Button
                    title="SUBMIT"
                    type="primary"
                    htmlType="submit"
                    loading={isloading}
                  />
                </div>
              </Form.Item>
            </Form>
          </div>
        </>
      </div>
    </Wrapper>
  );
};

export default ResetPassword;
